import { useState } from "react";
import { IStep } from "./StepTwo";
import UploadPhotos, { IFile } from "../../UploadPhotos/UploadPhotos";

const StepFour = ({ handleNext, handleBack, step }: IStep) => {
  const [filesArray, setFilesArray] = useState<IFile[]>([]);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <>
      <div className="assessment-card-container">
        <UploadPhotos
          filesArray={filesArray}
          setFilesArray={setFilesArray}
          setIsDeleting={setIsDeleting}
        />
      </div>
      <div className="btn-container marginTop">
        <button onClick={handleBack} className="outlined-button">
          Back
        </button>
        <button
          onClick={handleNext}
          className="button-dark"
          disabled={
            filesArray.length === 0 ||
            isDeleting ||
            filesArray.filter((file) => file?.deleting).length !== 0
          }
        >
          Next
        </button>
      </div>
    </>
  );
};

export default StepFour;
